module.exports = __webpack_public_path__ + "img/company-three.9a784bc0.jpg";